module.exports = __webpack_public_path__ + "img/try_5.14910c27.png";